import { Button } from '@mui/material';
import axios from 'axios';
import 'moment/locale/ru';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage';

import { Basket } from '../../Modules/Basket';
import { PaymentMethod, ReceivingMethod } from '../../api/def_common_api';
import { ReactComponent as Order_confirm_img } from '../../assets/images/basket/order_confirm.svg';
import { Util } from '../../common/util/util';
import { Icon } from '../../components';
import { useActions } from '../../hooks/useActions';
import { useBasket } from '../../hooks/useBasket';
import { useUser } from '../../hooks/useUser';
import { getStoreLocal } from '../../utils/local-storage';

import './index.sass';

//Информация о заказе
export const OrderInfo = () => {
  const location = useLocation();
  const {
    setAddCardsId,
    setAddOrderInfo,
    setAddPaymentMethod,
    setBasketCatalogItems,
    setOrderQuantity,
    setOrderSum,
    setAuthModal,
    setIsOffline,
    setPage,
  } = useActions();
  const { loggedIn } = useUser();
  const { paymentMethod, whereDeliveryTab } = useBasket();

  const [physicalTab] = useLocalStorage('physicalTab', true); // Физ. лицо или Юр. лицо
  const [addressValue, setAddAddressUser] = useLocalStorage('addAddressUser', {
    address: '',
    fullName: '',
    phone: '',
    comment: '',
  }); //Добавленные данные о пользователе
  const [cityFromStorage, setСityFromStorage] = useLocalStorage('city_value', {
    city: 'г. Владивосток',
    street: 'ул. Дальзоводская, 4, пав. 310',
    phone: '+7 (423) 246-48-64',
    position: 'left',
  }); //Город выбранный пользователем
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', ''); //Получить токен
  const [basketCards, setBasketCards] = useLocalStorage('basket', []);
  const getCheckoutData = getStoreLocal('checkout_data');
  const [orderInfoData, setOrderInfoData] = useState<any>({
    paid: true,
  }); //Информация о заказе
  const [loading, setLoading] = useState(false); //Загрузка

  let order_items = Util.clone(orderInfoData.order_items); //Получение элементов товара
  //Сортируем по продавцу (группировка)
  let order_items_sort =
    order_items &&
    order_items.sort((a: any, b: any) => a.vendor.id - b.vendor.id);
  let vendor_id_cur = '';
  let groups = []; //Группировка
  let group = {
    vendor: null,
    group_items: [],
  };
  let orderSum = Number(orderInfoData.order_sum_kopecks) - 50000;
  let order_sum_text = `${Util.convertKopecksToRub(
    orderInfoData.order_sum_kopecks
  )}`;
  //Проверка статуса оплачено или нет
  const [isPaid, setIsPaid] = useState(false);
  //Order info api
  const getOrderInfo = async (main_order_id: any) => {
    setLoading(true);
    const dataResponce = await axios({
      method: 'post',
      baseURL: process.env.REACT_APP_BASE_URL_API,
      url: '/api/admin/basket/order-info/' + String(main_order_id),
      headers: {
        'session-token': sessionToken ? sessionToken : '',
      },
    });
    if (!dataResponce.data.error) {
      setLoading(false);
      setOrderInfoData(dataResponce.data.order_info);
      setAddOrderInfo(dataResponce ? dataResponce.data.order_info : false);
      if (dataResponce.data.order_info.paid) {
        Basket.saveToLocalStorage([]);
      }
    }
    return dataResponce;
  };

  order_items_sort &&
    order_items_sort.forEach((item: any) => {
      if (vendor_id_cur != item.vendor.id) {
        //Другой продавец

        //Скидываем предыдущий набор
        if (group.vendor != null) {
          groups.push(group);

          //Обнуляем
          group = {
            vendor: null,
            group_items: [],
          };
        }

        group.vendor = item.vendor;
        //Набираем в группу товары
        // @ts-ignore
        group.group_items.push(item);

        vendor_id_cur = item.vendor.id;
      } else {
        //Набираем в группу товары
        // @ts-ignore
        group.group_items.push(item);
      }
    });
  //Скидываем предыдущий набор
  if (group.vendor != null) {
    groups.push(group);

    //Обнуляем
    group = {
      vendor: null,
      group_items: [],
    };
  }

  //Строка способ оплаты
  let get_payment_method_str = (payment_method: any) => {
    let retVal = '';

    switch (payment_method) {
      case PaymentMethod.PaymentOnDelivery:
        retVal = 'Наличными при получении товара';
        break;

      case PaymentMethod.PaymentOnline:
        retVal = 'Банковской картой на сайте';
        break;

      case PaymentMethod.BankTransfer:
        retVal = 'Банковской картой при получении товара';
        break;
    }

    return retVal;
  };

  const [paymentStatus, setPaymentStatus] = useState('waiting');
  const [error, setError] = useState<any>(null);
  const query = new URLSearchParams(location.search);
  //GateLine в merchant_order_id передает номер заказа
  let main_order_id = query.get('merchant_order_id');
  //Сюда пришли либо от GateLine либо от /checkout юр.лица
  if (location.state != undefined) {
    //Пришли от /checkout юр.лица
    // @ts-ignore
    main_order_id = location.state.main_order_id;
  }
  // функция проверки статуса оплаты
  const checkPaymentStatus = async () => {
    try {
      const { data } = await getOrderInfo(main_order_id); // замените на ваш URL запроса к серверу
      if (data.order_info.paid) {
        setIsPaid(true);
        setPaymentStatus('paid');
        if (data.order_info.payment_method === PaymentMethod.PaymentOnline) {
          //Очищаем корзину
          Basket.saveToLocalStorage([]);
          setBasketCatalogItems([]);
          setOrderSum(0);
          setOrderQuantity(0);
        }
      }
    } catch (err) {
      setError(err);
    }
  };

  // вызываем функцию проверки статуса оплаты каждую секунду
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!isPaid) {
        checkPaymentStatus();
      }
    }, 1000); // каждую секунду
    return () => clearInterval(intervalId);
  }, [isPaid]); // вызываем эффект, когда изменяется флаг оплаты

  useEffect(() => {
    if (
      !loading &&
      !orderInfoData.paid &&
      (orderInfoData.payment_method === PaymentMethod.PaymentOnDelivery ||
        orderInfoData.payment_method === PaymentMethod.BankTransfer)
    ) {
      setAddCardsId([]);
      /*Basket.saveToLocalStorageId([]);*/
      localStorage.setItem('basket', '');
      setBasketCatalogItems([]);
      setOrderQuantity(0);
      setOrderSum(0);
    }
    //Очищаем локальную корзину после подтверждения кода по sms, а то вдруг с sms проблемы, а корзина уже очищена
  }, [orderInfoData, loading]);

  useEffect(() => {
    setAddPaymentMethod(PaymentMethod.PaymentOnline);
    setPage('order');
  }, []);

  return (
    <div className="Order">
      <div className="Order__wrapper">
        <>
          {orderInfoData && (
            <div className="OrderInfo">
              <div className="OrderInfo_div">
                {/*Левая часть(Номер заказа...)*/}
                <div className="OrderInfo_div_left">
                  <h1>Спасибо! Ваш заказ оформлен!</h1>
                  <div className="OrderInfo_div_left_wrapper">
                    <div className="OrderInfo_div_left_order_confirm_img">
                      <Order_confirm_img />
                    </div>

                    {/*Номер заказа*/}
                    <div className="OrderInfo_div_left_n_div">
                      <span className="OrderInfo_div_left_n_div_span1">
                        Номер вашего заказа
                      </span>
                      <span className="OrderInfo_div_left_n_div_span2">
                        {orderInfoData.id}
                      </span>
                    </div>
                    {/*Статус*/}
                    <div className="OrderInfo_div_left_status_div">
                      <span className="OrderInfo_div_left_status_div_span1">
                        Статус:&nbsp;
                      </span>
                      <span className="OrderInfo_div_left_status_div_span2">
                        {isPaid ? 'Оплачено' : 'Ждёт оплаты'}
                      </span>
                    </div>
                    <span className="OrderInfo_div_left_details">
                      Информация о получении
                    </span>
                    <span className="OrderInfo_div_left_sposob">
                      Способ получения:
                      <span className="OrderInfo_div_left_sposob_text">
                        {orderInfoData.receiving_method ==
                        ReceivingMethod.SelfDelivery
                          ? 'Самовывоз из магазина'
                          : 'Доставка'}
                      </span>
                    </span>
                    <span className="OrderInfo_div_left_sposob">
                      {/*                     {orderInfoData.receiving_method == ReceivingMethod.SelfDelivery
                        ? 'Адрес магазина'
                        : orderInfoData.receiving_method == ReceivingMethod.Delivery && orderInfoData.delivery_address.length == 0
                        ? 'ФИО получателя'
                        : 'Адрес доставки'}*/}
                      {orderInfoData.receiving_method ==
                      ReceivingMethod.SelfDelivery
                        ? 'Адрес магазина:'
                        : orderInfoData.receiving_method ==
                            ReceivingMethod.Delivery &&
                          orderInfoData.delivery_address.length == 0
                        ? 'Адрес доставки:'
                        : 'Адрес доставки:'}
                      {/*                      {orderInfoData.receiving_method == ReceivingMethod.SelfDelivery ? (
                        <span className="OrderInfo_div_left_sposob_address">{`${cityFromStorage.city}, ${cityFromStorage.street}`}</span>
                      ) : orderInfoData.receiving_method == ReceivingMethod.Delivery && orderInfoData.delivery_address.length == 0 ? (
                        <p>{orderInfoData.other_recipient_name}</p>
                      ) : (
                        <p>{orderInfoData.delivery_address}</p>
                      )}*/}
                      {orderInfoData.receiving_method ==
                      ReceivingMethod.SelfDelivery ? (
                        <span className="OrderInfo_div_left_sposob_address">{`${cityFromStorage.city}, ${cityFromStorage.street}`}</span>
                      ) : orderInfoData.receiving_method ==
                          ReceivingMethod.Delivery &&
                        orderInfoData.delivery_address.length == 0 ? (
                        <p>{orderInfoData.delivery_address}</p>
                      ) : (
                        <p>{orderInfoData.delivery_address}</p>
                      )}
                    </span>
                    <span className="OrderInfo_div_left_sposob">
                      Режим работы:
                      <span className="OrderInfo_div_left_sposob_text">
                        Пн-Пт с 9:00 до 18:00, Сб с 9:00 до 15:00
                      </span>
                    </span>
                    <span className="OrderInfo_div_left_sposob">
                      {/*                      {orderInfoData.receiving_method == ReceivingMethod.SelfDelivery
                        ? 'Телефон:'
                        : orderInfoData.receiving_method == ReceivingMethod.Delivery && orderInfoData.delivery_address.length == 0
                        ? 'Телефон получателя:'
                        : 'Телефон:'}*/}
                      Телефон:
                      <span className="OrderInfo_div_left_sposob_text">
                        {getCheckoutData.checkout_phone}
                      </span>
                    </span>
                    <span className="OrderInfo_div_left_details">
                      Информация о оплате
                    </span>
                    <span className="OrderInfo_div_left_sposob">
                      Способ оплаты:
                      <span className="OrderInfo_div_left_sposob_text">
                        {get_payment_method_str(orderInfoData.payment_method)}
                      </span>
                      {/*{get_payment_method_str(orderInfoData.payment_method)}*/}
                    </span>
                    {/* <span className="OrderInfo_div_left_sposob">Статус оплаты: Ожидает оплаты</span> */}
                    <div className="OrderInfo_div_left_sposob_btns">
                      <Button
                        variant="orange"
                        color="primary"
                        className="OrderInfo_div_left_link orange"
                        href="/"
                      >
                        Вернуться к покупкам
                      </Button>
                      {!getCheckoutData.is_physical_person &&
                        orderInfoData.payment_method ===
                          PaymentMethod.BankTransfer && (
                          <Button
                            variant="blue"
                            color="primary"
                            className="OrderInfo_div_left_link blue"
                            href={orderInfoData.doc_url}
                          >
                            Скачать счет
                          </Button>
                        )}
                      {/*{physicalTab && paymentMethod === PaymentMethod.PaymentOnDelivery && (
                        <Button className="OrderInfo_div_left_link blue" href={orderInfoData.doc_url} variant="contained">
                          Скачать счет
                        </Button>
                      )}*/}
                    </div>
                  </div>
                  <p className="OrderInfo_div_left_descr">
                    Если Вам нужна какая-либо консультация по поводу заказа,
                    свяжитесь с нами по телефону 8 (423) 246-48-46
                  </p>
                </div>
                {/*Правая часть(Состав заказа)*/}
                <div className="OrderInfo_div_right">
                  <span className="OrderInfo_div_right_title">
                    Состав заказа
                  </span>
                  <div className="OrderInfo_div_right_list">
                    {groups.map((gr: any) => {
                      return (
                        <div
                          className="BasketPage_div_left_group order"
                          key={'basket_group_' + gr.vendor.id}
                        >
                          <div className="BasketPage_div_left_group_top">
                            <Icon variant="shop" />
                            <span className="BasketPage_div_left_group_caption">
                              {gr.vendor.title}
                            </span>
                          </div>
                          {gr.group_items.map((item: any) => {
                            return (
                              <div
                                key={item.id}
                                className="OrderInfo_div_right_list_item"
                              >
                                <div className="OrderInfo_div_right_list_item_img">
                                  <img src={item.img_url}></img>
                                </div>
                                <div className="OrderInfo_div_right_list_item_right">
                                  <div className="OrderInfo_div_right_list_item_title_div">
                                    <span className="OrderInfo_div_right_list_item_title_div_span1">
                                      {item.title}
                                    </span>
                                  </div>
                                  <div className="OrderInfo_div_right_list_item_wrapper">
                                    <div className="OrderInfo_div_right_list_item_sum">
                                      <div className="OrderInfo_div_right_list_item_sum_price">
                                        {Util.convertKopecksToRub(
                                          item.price_kopecks
                                        )}
                                      </div>
                                      <div className="OrderInfo_div_right_list_item_sum_valut">
                                        {' '}
                                        &nbsp;₽
                                      </div>
                                    </div>
                                    <div className="OrderInfo_div_right_list_item_quantity">
                                      {item.quantity} &nbsp;
                                      {item.unit}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                  <hr
                    className={
                      orderInfoData.receiving_method ==
                      ReceivingMethod.SelfDelivery
                        ? 'OrderInfo_div_right_bottom itogo active'
                        : 'OrderInfo_div_right_bottom itogo'
                    }
                  />
                  <div className="OrderInfo_div_right_itog">
                    <span className="OrderInfo_div_right_itog_itogo">
                      Итого:
                    </span>
                    <span className="OrderInfo_div_right_itog_sum">
                      <div>
                        {orderInfoData.receiving_method ==
                        ReceivingMethod.Delivery
                          ? Number(order_sum_text) - 500
                          : order_sum_text}
                      </div>
                      <div>₽</div>
                    </span>
                  </div>
                  {orderInfoData.receiving_method ==
                    ReceivingMethod.Delivery && (
                    <>
                      <div className="OrderInfo_div_right_itog devel">
                        <span className="OrderInfo_div_right_itog_itogo">
                          Итого с доставкой:
                        </span>
                        <span className="OrderInfo_div_right_itog_sum">
                          <div>{order_sum_text}</div>
                          <div>₽</div>
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};
